module.exports = __webpack_public_path__ + "static/media/biking.ba65abd6.svg";